// CAROUSEL WITH MULTIPLE ITEMS
( function ($) {
    $(document).ready(function () {
        childrenSlider();
    });
    function childrenSlider() {
        var wraps = $('.post_preview.layout_carousel');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.children_section'),
                    elements = slider.children(),
                    hasCarousel = false;

                if(is_phone && elements.length > 1){
                    hasCarousel = true;
                } else if(is_mobile && elements.length > 2){
                    hasCarousel = true;
                } else{
                    if(elements.length > 3){
                        hasCarousel = true;
                    }
                }

                if (slider.length > 0 && hasCarousel) {
                    slider.on("init", function () {
                        lazyLoadInstance.update();
                        wrap.addClass('carousel-loaded');
                    });
                    slider.not('.slick-initialized').slick({
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        dots: true,
                        customPaging: function(slider, i) {
                            return $('<button type="button" />');
                        },
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true
                                }
                            },
                        ]
                    });
                }
            })
        }
    }
}(jQuery) );